/** Indian grouping, whole rupees only (no paise / decimals in UI). */
const INR_OPTS = { maximumFractionDigits: 0, minimumFractionDigits: 0 };

export function formatAdminPrice(value) {
  const n = Math.round(Number(value ?? 0));
  if (Number.isNaN(n)) return '0';
  return n.toLocaleString('en-IN', INR_OPTS);
}

export function formatAdminInr(value) {
  return `₹${formatAdminPrice(value)}`;
}

/** Controlled inputs: strip .00 from API decimals; whole numbers only. */
export function priceInputString(value) {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return String(Math.round(n));
}
